import React, {Component} from 'react'

import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'

import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'

/**
 * <EditCategoryDialog category onUpdateCategory = {category} onCancel = {} />
 */

class EditCategoryDialog extends Component {

	state = {
		name: "",
	}

	isReadyToUpdate() {
		if (this.state.name === "") {
			return false
		}
		if (this.state.name !== this.props.category.name) {
			return true
		}
		return false
	}

	componentDidMount(prevProps) {
		this.setState({
			name: this.props.category.name,
		})
	}

	render() {

		return <Dialog
			open = {true}
			scroll = "body"
		>

			<DialogTitle>
				Редактировать категорию
			</DialogTitle>

			<DialogContent style = {{display: "flex", flexDirection: "column"}}>
				<TextField
					value = {this.state.name}
					label = "Название категории"
					margin = "normal"
					onChange = {e => {
						this.setState({
							name: e.target.value
						})
					}}
				/>
			</DialogContent>

			<DialogActions>

				<Button
					disabled = {!this.isReadyToUpdate()}
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onUpdateCategory === "function") {
							this.props.onUpdateCategory({
								id: this.props.category.id,
								name: this.state.name,
							})
						}
					}}
				>Сохранить</Button>

				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onCancel === "function") {
							this.props.onCancel()
						}
					}}
				>Отмена</Button>

			</DialogActions>
			
		</Dialog>

	}

}

export default EditCategoryDialog
